import React from "react";
import { Button } from "reactstrap";
import "./styles/book-articles.css";

const BookArticles = ({
  book,
  t,
  renderAuthors,
  modalToggleAudioArticle,
  handleAddToQueue,
  handlePlayAll,
  handleQueueAll,
}) => {
  if (!book.articles || book.articles.length === 0) return null;

  const audioArticles = book.articles.filter((a) => !!a.audioUrl || !!a.audiourl);

  return (
    <div className="book-articles mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="bold">
          {t(book.number ? "articles" : "contents")}:
        </span>
        {audioArticles.length > 1 && (
          <Button
            color="outline-primary"
            size="sm"
            className="rounded-pill px-3"
            onClick={() => handleQueueAll(audioArticles)}
          >
            <i className="fa fa-list-ol me-2"></i>
            {t("queue-all") || "Queue All"}
          </Button>
        )}
      </div>

      <div className="article-list">
        {book.articles.map((a, i) => (
          <div key={i} className="article-row">
            <div className="d-sm-flex justify-content-between align-items-center">
              <div className="flex-grow-1">
                <div className="article-title">{a.title}</div>
                {book.number && (
                  <div className="article-meta text-muted">
                    {renderAuthors([a.author])} — {a.description}
                  </div>
                )}
              </div>
              {a.audioUrl || a.audiourl ? (
                <div className="ms-sm-4 d-flex gap-2 align-items-center mt-2 mt-sm-0">
                  <Button
                    className="btn btn-outline-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      modalToggleAudioArticle(a);
                    }}
                  >
                    <i className="fa fas fa-volume-up"></i>
                    <span className="ms-2">{t("listen-online")}</span>
                  </Button>
                  <Button
                    outline
                    color="secondary"
                    className="btn-add-queue"
                    title={t("add-to-queue") || "Add to Queue"}
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddToQueue(a);
                    }}
                  >
                    <i className="fa fa-plus"></i>
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookArticles;
